module.exports = __webpack_public_path__ + "img/讚不絕口.7ec9590e.svg";